import React__default from 'react';
import classnames from 'classnames';

const ButtonGroup = _ref => {
  let {
    children,
    fluid = false,
    layout = 'stacked',
    breakpoints = {},
    placement = 'left',
    className
  } = _ref;
  const breakpointKeys = Object.keys(breakpoints);
  const breakpointClassnames = breakpointKeys.reduce((classNames, breakpoint) => {
    if (!breakpoints[breakpoint]) return classNames;
    const {
      layout,
      placement,
      fluid
    } = breakpoints[breakpoint];
    return {
      ...classNames,
      [`b-btn-group__${breakpoint}--fluid`]: fluid,
      [`b-btn-group__${breakpoint}--static`]: !fluid,
      [`b-btn-group__${breakpoint}--${layout}`]: Boolean(layout),
      [`b-btn-group__${breakpoint}--${layout}-${placement}`]: Boolean(placement)
    };
  }, {});
  return /*#__PURE__*/React__default.createElement("div", {
    className: classnames(className, 'b-btn-group', `b-btn-group--${layout}`, `b-btn-group--${layout}-${placement}`, {
      'b-btn-group--fluid': fluid,
      'b-btn-group--static': !fluid
    }, breakpointClassnames)
  }, children);
};
ButtonGroup.displayName = 'ButtonGroup';

export { ButtonGroup };
